<template>
  <div class="epidemic-situation-register">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: space-between">
        <input-select
          selectTitle="健康状态"
          :selectKey="'healthStatus'"
          :selectData="healthStatusList"
          @search="search"
        />
      </div>
      <div style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right:3px">
        <span class="selectTitle">假期所在地</span>
        <el-select v-model="requestData.province" @change="provinceChange" placeholder="请选择" size="small" style="width: 140px;">
          <el-option
            v-for="item in provinceList"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        <el-select v-model="requestData.city" @change="cityChange" placeholder="请选择" size="small" style="width: 140px;">
          <el-option
            v-for="item in cityList"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        <el-select v-model="requestData.region" @change="regionChange" placeholder="请选择" size="small" style="width: 140px;">
          <el-option
            v-for="item in regionList"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="姓名/手机号/住户/房间号" @search="searchKey" />
      </div>
    </div>
    <table-main
      :selection="false"
      :tableHead="tableHead"
      :tableData="tableData"
      @changeSelection="changeSelection"
      :total="total"
      :pageNum="requestData.pageNum"
      :pageSize="requestData.pageSize"
      :row-click="showDrawer"
      @changePagination="changePagination"
      :hasOperation="false"
    />

    <el-drawer :visible.sync="drawer" :with-header="false" size="80%">
      <div class="person-management-drawer">
        <button @click="closeDrawer" class="el-icon-back"></button>
        <form>
          <div class="form-title">人员信息</div>
          <div class="form-line">
            <div>
              <div class="line-text">姓名：</div>
              <div class="line-info">{{currentPersonData.personName || '无'}}</div>
            </div>
            <div>
              <div class="line-text">性别：</div>
              <div class="line-info">{{currentPersonData.sexText || '无'}}</div>
            </div>
            <div>
              <div class="line-text">手机号：</div>
              <div class="line-info">{{currentPersonData.personPhone || '无'}}</div>
            </div>
          </div>
          <div class="form-line">
            <div>
              <div class="line-text">房间号：</div>
              <div class="line-info">{{currentPersonData.roomInfoName || '无'}}</div>
            </div>
            <div>
              <div class="line-text">住户名称：</div>
              <div class="line-info">{{currentPersonData.enterpriseName || '无'}}</div>
            </div>
            <div>
              <div class="line-text">健康状态：</div>
              <div class="line-info">{{currentPersonData.healthStatusText || '无'}}</div>
            </div>
          </div>

          <div class="form-title">居住信息</div>
          <div class="form-line">
            <div>
              <div class="line-text">户籍：</div>
              <div class="line-info">{{currentPersonData.nativePlace || '无'}}</div>
            </div>
            <div>
              <div class="line-text">假期所在地：</div>
              <div
                class="line-info"
                v-if="currentPersonData.province"
              >{{currentPersonData.province}}{{currentPersonData.city}}{{currentPersonData.region}}</div>
              <div class="line-info" v-else>无</div>
            </div>
            <div>
              <div class="line-text">详细地址：</div>
              <div class="line-info">{{currentPersonData.address || '无'}}</div>
            </div>
          </div>
          <div class="form-line">
            <div>
              <div class="line-text">工作地住址：</div>
              <div class="line-info">{{currentPersonData.workAddress || '无'}}</div>
            </div>
          </div>

          <div class="form-title">复工信息</div>
          <div class="form-line">
            <div>
              <div class="line-text">复工时间：</div>
              <div class="line-info">{{currentPersonData.returnWorkDate || '无'}}</div>
            </div>
            <div>
              <div class="line-text">是否返回工作所在地：</div>
              <div class="line-info">{{currentPersonData.workAddressFlag}}</div>
            </div>
            <div>
              <div class="line-text">返程时间：</div>
              <div class="line-info">{{currentPersonData.returnDate || '无'}}</div>
            </div>
          </div>
          <div class="form-line">
            <div>
              <div class="line-text">涉及交通工具：</div>
              <div class="line-info">{{currentPersonData.vehical || '无'}}</div>
            </div>
            <div>
              <div class="line-text">班次时间：</div>
              <div class="line-info">{{currentPersonData.vehicalDescription || '无'}}</div>
            </div>
          </div>

          <div class="form-title">个人健康</div>

          <div class="form-line">
            <div class="health-line">
              有无发热、咳嗽、乏力等症状：{{currentPersonData.feverFlag || '无'}}
            </div>
          </div>
          <div class="form-line" v-if="currentPersonData.feverFlag === '有'">
            <div>
              <div class="line-text">症状描述：</div>
              <div class="line-info">{{currentPersonData.feverMemo || '无'}}</div>
            </div>
          </div>
          <div class="form-line">
            <div class="health-line">
              有无新型冠状病毒感染者（含疑似病例）接触史：{{currentPersonData.contactFlag || '无'}}
            </div>
          </div>
          <div class="form-line">
            <div class="health-line">
              近一个月内是否有重点疫区（如湖北、温州、台州地区）停留史：{{currentPersonData.stayFlag || '无'}}
            </div>
          </div>
          <div class="form-line" v-if="currentPersonData.stayFlag === '有'">
            <div>
              <div class="line-text">情况描述：</div>
              <div class="line-info">{{currentPersonData.stayMemo || '无'}}</div>
            </div>
          </div>
        </form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/epidemicSituation";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import { cityData } from "../../../utils/citys";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "epidemic-situation-register",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧防疫",
          name: "epidemic-situation-register"
        },
        {
          value: "防疫登记"
        }
      ],
      exportUrl: "",
      healthStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "正常"
        },
        {
          key: "1",
          label: "异常"
        }
      ],
      provinceList: [],
      cityList: [],
      regionList: [],
      tableHead: [
        {
          prop: "personName",
          label: "姓名"
        },
        {
          prop: "sexText",
          label: "性别",
          width: '80',
        },
        {
          prop: "personPhone",
          label: "手机号"
        },
        {
          prop: "roomInfoName",
          label: "房间号"
        },
        {
          prop: "enterpriseName",
          label: "住户名称"
        },
        {
          prop: "jqszd",
          label: "假期所在地"
        },
        {
          prop: "returnDate",
          label: "返程时间"
        },
        {
          prop: "healthStatusText",
          label: "健康状态"
        },
        {
          prop: "registerTime",
          label: "登记时间"
        }
      ],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        healthStatus: "",
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        province: '',
        city: '',
        region: '',
      },
      drawer: false,
      currentPersonData: {}
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    let searchdata = this.$route.params.id
    if (searchdata === '1') {
      this.requestData.province = '湖北省'
    } else if (searchdata === '2') {
      this.requestData.province = '浙江省'
      this.requestData.city = '温州市'
    } else if (searchdata === '3') {
      this.requestData.province = '浙江省'
      this.requestData.city = '台州市'
    } else if (searchdata === '4') {
      this.requestData.province = '浙江省'
      this.requestData.city = '宁波市'
    }
    this.getPage();
    this.provinceList = cityData
  },
  methods: {
    // beforeDownload () {
    //   this.exportUrl = `${api.exportRepairCategory}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&status=${this.requestData.status}`
    // },
    getPage() {
      this.$axios
        .post(api.getEpidemicRegisterPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.sex === "0") {
                v.sexText = "男";
              } else {
                v.sexText = "女";
              }
              if (v.healthStatus === "1") {
                v.healthStatusText = "异常";
              } else if (v.healthStatus === "0") {
                v.healthStatusText = "正常";
              }
              if (v.province) {
                v.jqszd = `${v.province}${v.city}${v.region}`
              } else {
                v.jqszd = ``
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取失败"));
    },
    search(v) {
      this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    closeDrawer() {
      this.drawer = false;
    },

    showDrawer(row, event, column) {
      this.drawer = true;
      this.currentPersonData = row;
    },

    provinceChange (value) {
      this.provinceList.map(v => {
        if (v.label === value) {
          this.cityList = v.children
        }
      })
      this.requestData.city = ''
      this.requestData.region = ''
      this.getPage()
    },

    cityChange (value) {
      this.cityList.map(v => {
        if (v.label === value) {
          this.regionList = v.children
        }
      })
      this.requestData.region = ''
      this.getPage()
    },

    regionChange (value) {
      this.getPage()
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.epidemic-situation-register {
  .person-management-drawer {
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .el-icon-back:hover {
      color: #00a0e6;
    }
    .all-table-class .el-table td {
      padding: 10px 0;
    }

    form {
      width: 90%;
      margin: 0 auto;
    }

    .form-title {
      color: #333333;
      font-size: 16px;
      line-height: 28px;
      padding-left: 5px;
      border-left: 3px solid #00a0e6;
      text-align: left;
    }
    .form-line {
      margin: 15px 0;
      display: flex;
      justify-content: flex-start;
    }
    .form-line > div {
      display: flex;
      justify-content: flex-start;
    }
    .line-text {
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 140px;
      text-align: right;
    }
    .health-line {
      color: #48576a;
      font-size: 14px;
      text-align: left;
      padding: 0 0 0 40px;
    }
    .line-info {
      width: 200px;
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/EpidemicSituation/EpidemicSituationRegister/EpidemicSituationRegister.vue